import { Card, Icon, SearchSVG } from "@newsela/angelou";
import { ContentProps } from "@/components/ContentPromotions/types/ContentProps.interface";

import {
  cardContentCss,
  cardTitleCss,
  cardIconCss,
  cardCss,
} from "./ReadingSkillsCard.style";

interface ReadingSkillsCardProps {
  cardIndex?: number;
  showIcon?: boolean;
}

const ReadingSkillsCard = (props: ContentProps & ReadingSkillsCardProps) => {
  const { href, title, showIcon = true, cardIndex = 0 } = props;
  const searchEventProperties = {
    objectType: "Content",
    actionPrefix: "Initiate",
    actionName: "Navigate",
    streamProperties: {
      description:
        "Redirect to search page from Platfom Alignment Form Content Preview page",
    },
  };

  return (
    <Card
      __css={cardCss(cardIndex)}
      dataProps={{
        "data-qa-selector": `${title ?? ""}-search-card`,
      }}
      href={href}
      {...searchEventProperties}
    >
      <div css={cardContentCss}>
        {showIcon && (
          <Icon
            SvgComponent={SearchSVG}
            title="Search"
            size={Icon.sizes.lg}
            __cssFor={{ root: cardIconCss }}
          />
        )}
        <div css={cardTitleCss}>{title}</div>
      </div>
    </Card>
  );
};

export default ReadingSkillsCard;
